import { createFileRoute, redirect } from '@tanstack/react-router'

/** The bare path lands on the Sites & assets register's Assets view (every site's assets). */
export const Route = createFileRoute('/_app/service/assets/')({
  beforeLoad: () => {
    throw redirect({ to: '/service/sites', search: { view: 'assets' }, replace: true })
  },
})
